<!-- Booking Cancellation Modal -->
<p-dialog [(visible)]="isVisible" [modal]="true" [styleClass]="'booking-cancellation-modal'" [maximizable]="false"
    [resizable]="false" [closeOnEscape]="false" [blockScroll]="true" (onHide)="onDialogHide()">
    <p-header>{{ getModalTitle() }}</p-header>
    <p-body class="p-2 text-center">
        <div class="row">
            <div class="col-md-12 text-left">
                <label for="cancellationDate"><b>Cancellation Date:</b></label>
                <p-calendar [(ngModel)]="cancellationDate" dateFormat="dd/mm/yy" [maxDate]="maxDate" appendTo="body"
                    [showIcon]="true" inputId="buttondisplay" [showOnFocus]="false" class="custom-calendar" />
            </div>
            <div class="col-md-12 text-left">
                <label for="cancellationReason"><b>Cancellation Reason:</b></label>
                <textarea id="cancellationReason" [(ngModel)]="cancellationReason" rows="4" class="form-control"
                    placeholder="Enter cancellation reason here..."></textarea>
            </div>
            <div class="col-md-12 text-left">
                <label for="cancellationScreenshot"><b>Upload Request Screenshot:</b></label> &nbsp;
                <img [src]="cancellationScreenshotIcon" height="20" width="20" id="cancellationScreenshotIcon"
                    style="cursor: pointer;" (click)="setCurrentFileConfig()">
                <i class="pi pi-eye pi-icons ml-2" aria-hidden="true" style="cursor: pointer;"
                    [ngClass]="{'pi-disabled': !cancellationScreenshot}" (click)="openImagePreview()"
                    [style.opacity]="cancellationScreenshot ? 1 : 0.5"
                    [style.pointer-events]="cancellationScreenshot ? 'auto' : 'none'">
                </i>
            </div>
            <div class="col-md-12 text-right mt-3">
                <button pButton type="button" [label]="getSubmitButtonLabel()" icon="pi pi-check"
                    class="btn btn-primary" (click)="onSubmit()"
                    [disabled]="!cancellationReason || cancellationReason.length==0 || isSubmitting"
                    [loading]="isSubmitting"></button>
                &nbsp;
                <button pButton type="button" label="Close" icon="pi pi-times" class="btn btn-secondary"
                    (click)="onModalClose()" [disabled]="isSubmitting"></button>
            </div>
        </div>
    </p-body>
</p-dialog>

<!-- Document Screenshot Upload Modal -->
<p-dialog [(visible)]="displayDocumentFileDialogue" [closeOnEscape]="false" [modal]="true" [draggable]="false"
    [resizable]="false" [blockScroll]=false [style]="{ width: '30rem' }">
    <p-header>
        Upload {{ documentFileData?.picFor }} Pic
    </p-header>
    <app-document-file [fileDataConfig]='documentFileData'
        (documentFile)="onDocumentFileReceived($event)"></app-document-file>
</p-dialog>

<!-- Image Preview Modal -->
<app-picview *ngIf="showclickedPic" (closePicDialogue)="showclickedPic = false" [picData]="picViewData"></app-picview>